import React, { useEffect, useState } from "react";
import { XCircleIcon } from "@heroicons/react/solid";
import ReactQuill from "react-quill";
import { toast } from "react-toastify";
import "react-quill/dist/quill.snow.css";

const SendEmailModal = (props) => {
  const [to, setTo] = useState();
  const [subject, setSubject] = useState();

  const [message, setMessage] = useState();

  let handelEditor = (state) => {
    setMessage(state);
  };

  let handelsubmitMessage = () => {
    let {} = props.campaignData
    if (to && subject && message) {
      let data = {
        to,
        subject,
        message,
      };
      props.sendEmailInvite(data);
    } else {
      toast("All feilds are required!", {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }
  };

  useEffect(() => {
    let { value } = props;
    let { emailTemplate, emailSubject } = props.campaignData;
    setTo(value);
    setMessage(emailTemplate);
    setSubject(emailSubject);
  }, [props]);

  return (
    <div>
      <div className="flex justify-end items-center">
        <XCircleIcon
          onClick={props.close}
          className="w-7 h-7 cursor-pointer text-[#FEBB12] "
          color="white"
        />
      </div>
      <div className="px-6 pt-8">
        <div className="flex flex-row items-center">
          <p className="text-[#212529] font-semibold mr-16">To: </p>
          <input
            disabled={true}
            onChange={(e) => setTo(e.target.value)}
            defaultValue={to}
            className="w-full text-sm bg-[#F8F9FA] py-3 px-2 focus:outline-none focus:bg-[#F8F9FA] focus:border-gray-500"
          />
        </div>
        <div className="flex flex-row items-center  my-4">
          <p className="text-[#212529] font-semibold mr-7">Subject:</p>
          <input
            onChange={(e) => setSubject(e.target.value)}
            value={subject}
            className="w-full text-sm bg-[#F8F9FA] py-3 px-2 focus:outline-none focus:bg-[#F8F9FA] focus:border-gray-500"
          />
        </div>

        <ReactQuill
          name="emailTemplate"
          value={message}
          onChange={handelEditor}
          defaultValue={message}
          style={{ height: 100 }}
        />

        <div className="mt-14 flex justify-end">
          <button
            onClick={handelsubmitMessage}
            className="bg-[#FEBB12] font-normal text-[#333333] border-1 border-[#EBEBEB] rounded-md px-6 py-2"
          >
            Send Message
          </button>
        </div>
      </div>
    </div>
  );
};

export default SendEmailModal;
